import * as React from 'react';
import { Row, Col, Icon, Tabs, Button, Tooltip, message, Menu, Dropdown } from 'antd';
import injectSheet from 'react-jss';
import BidCardShipper from './Cards/ShipperBidCard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter, applyFilter, resetFilters, enableBidLoading, disableBidLoading, getBidsEnquiry }
  from 'src/actions/inquiryShipperActionsBids';
import Loader from 'src/components/common/Loader';
import { downloadBidsForShipper, fetchInquiryDetailsForShipper } from 'src/api/inquiry';
import { downloadFileData } from 'src/utils/utils';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import LightHouseIcon from 'src/components/common/icons/LightHouseIcon';
import SendRFQ from 'src/components/pages/Enquiry/Modals/SendRFQ';
import { withRouter } from 'react-router';
import ShipperBidsSortByModal from './Modals/ShipperBidsSortByModal';
import SortIcon from 'src/components/common/icons/SortIcon';
import ShipperBidsFilterModal from './Modals/ShipperBidsFilterModal';
import withInquiryMasterData from './hoc/InitInquiryMaster';
import { INQUIRY_SHIPPER } from 'src/utils/partsToShow/partsConstants';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import TaxWarning from '../../common/TaxWarning';
import { CompareArrowsIcon } from 'src/components/common/icons/CompareArrowsIcon';
import CompareBidsModal from './Modals/CompareBidsModal';
import { getUnitByMode } from './InquiryUtils';
import { getAddOfflineBidRoute } from 'src/routing/utils';
import EditReferenceRateModal from './Modals/editReferenceRateModal';
import { isValidArray } from 'src/Library/Helper';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import { getRefRateUnit } from './Cards/InquiryCommon';
import { InquiryModes } from 'src/Library/Constants';
import ExtendDeadlineModal from 'src/components/pages/Enquiry/Modals/ExtendDeadlineModal';
import { disableAddOfflineBidForDomestic } from './constants';
import { tokens } from 'src/design-system';

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#F9F9F9',
  LIGHTGREY: '#D9D9D9',
};
const styles = theme => ({
  tabpane: {
    '& .ant-tabs-tab ': {
      marginBottom: '0 !important',
      paddingBottom: '16px !important',
      paddingTop: '0px !important',
      paddingLeft: '24px !important',
      textAlign: 'left !important',
      paddingRight: '233px !important',
    },
  },
  tab: {
    marginBottom: '0px',
    paddingTop: '4px',
  },
  shadow: {
    border: '1px solid #D9D9D9',
    opacity: '0.5',
    marginLeft: '0px',
  },
  shadow2:
  {
    border: '1px solid #D9D9D9',
    width: '100%',
    opacity: '0.5',
    marginLeft: '0px',
    marginRight: 'auto',
  },
  paragraph: {
    fontsize: '11px',
    paddingLeft: '24px',
    paddingTop: '17px',
    fontfamily: 'Open Sans',
  },
  anchorTags: {
    fontsize: '11px',
    paddingLeft: '24px',
    paddingTop: '17px',
    fontfamily: 'Open Sans SemiBold',
    color: tokens.colors.primary,
    display: 'block',
    fontWeight: `${tokens.fontWeight.semibold}`,
  },
  darkFont:
  {
    color: '#262626 ',
    font: '18px Open Sans',
  },
  row2:
  {
    '& .ant-row': {
      marginLeft: '5px !important',
      paddingLeft: '0px !important',
    },
  },
  verticalLine:
  {
    border: '1px solid #D9D9D9',
    height: '37px',
    width: '2px',
  },
  notFound: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  errorBlock: {
    margin: '15px',
  },
  compareBidsButton: {
    padding: '8px',
    margin: '8px 12px 0px 0px',
    backgroundColor: '#0780FE',
    border: '#0780FE',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'unset',

    '&:focus': {
      backgroundColor: '#0780FE',
      border: '#0780FE',
    },
  },
  addBidsButton: {
    padding: '8px',
    margin: '8px 12px 0px 0px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'unset',
  },
  disabledButton: {
    padding: '8px 8px 0px 0px',
    backgroundColor: 'unset',
    border: '#0780FE',
    display: 'flex',
    alignItems: 'center',
  },
  rightHeader: {
    marginRight: '24px',
    marginTop: '12px',
    fontSize: `${tokens.fontSize.h1}px`,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  highValue: {
    backgroundColor: '#1990ff',
    padding: '5px',
    borderRadius: '5px',
    color: 'white',
    height: '15px',
    fontSize: '8px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold'
  }
});
class ShippersEnquiry extends React.PureComponent<any, any> {
  state: any = {
    bidConfirmed: false,
    ShipperBidsFilterModalVisible: false,
    clearVisible: false,
    ShipperBidsSortByModalVisible: false,
    sendRFQConfirmationVisible: false,
    fileError: '',
    fileLink: '',
    compareBidsModalVisible: false,
    isEditRRModalActive: false,
    inquiryData: this.props.inquiryData,
  };

  //interval for auto refresh
  interval: NodeJS.Timeout;

  loadInquiryData = async() => {
    this.props.enableBidLoading()
    const { match } = this.props;
    const inquiryId = match.params.inquiryId;
    const tabId = match.params.tabId;
    tabId === 'details' ? this.setState({ activeKey : '1' }) : this.setState({ activeKey: '2' });
    this.props.getBidsEnquiry(inquiryId)
    const response = await fetchInquiryDetailsForShipper({ inquiryId });
    if (response.isSuccess) {
      this.setState({
        inquiryData: response.data,
        newDeadline: response.data.deadline,
      });
    }
    this.props.disableBidLoading()
  }

  componentDidMount() {
    const { shouldResetFilter, inquiryData } = this.props;
    if (shouldResetFilter) {
      this.props.resetFilters(inquiryData.id);
    }
    this.loadBidData();
    this.interval = setInterval(() => this.loadBidData(), 60000);
  }

  loadBidData = async () => {
    await this.loadInquiryData();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleCompareBids = () => {
    sendEvent(
      EventCategories.INQUIRY_BID_CONFIRMATION,
      'Compare Bids',
    );
    this.setState({ compareBidsModalVisible: true });
  }

  handleDownload = async (body) => {
    let res : any;
    let extensionIncluded = false;
    this.setState({ isDownloadLoading : true });
    res = await downloadBidsForShipper(body);
    if (res.isSuccess) {
      if (body.documentType === 'PDF') {
         extensionIncluded = true;
      }
      const link = downloadFileData(res.data, res.filename,extensionIncluded);
      this.setState({ fileLink: link });
      message.success('Downloaded Successfully.');
    } else {
      message.error(res.errorMessage || 'No Bids to Download.');
    }
    this.setState({
      fileError: res.errorMessage,
    });
    this.setState({ isDownloadLoading : false });
  }

  clearFilters = () => {
    this.props.resetFilters(this.props.inquiryData.id);
    this.setState({
      ShipperBidsFilterModalVisible: false,
    });
  }

  handleCompareBidsCancel = () => {
    this.props.resetFilters(this.props.inquiryData.id);
    this.setState({ compareBidsModalVisible: false });
  }

  handleOkShipper = () => {
    this.setState({
      ShipperBidsFilterModalVisible: false,
    });
    this.props.applyFilter(this.props.inquiryData.id);
  }

  handleCancelShipper = () => {
    this.setState({
      ShipperBidsFilterModalVisible: false,
    });
    this.props.setFilter({
      shippingLineList: this.props.appliedFilters.shippingLineList,
      ffIdList: this.props.appliedFilters.ffIdList,
      bidStatusList: this.props.appliedFilters.bidStatusList,
    });
  }

  sendRFQConfirmationHandleOk = async () => {
    this.setState({ sendRFQConfirmationVisible: false });
    await this.loadInquiryData();
  }

  sendRFQConfirmationHandleCancel = () => {
    this.setState({ sendRFQConfirmationVisible: false });
  }

  showSendRfqModal = () => {
    this.setState({ sendRFQConfirmationVisible: true });
  }

  handleAddOfflineBid = () => {
    const { history, inquiryData } = this.props;
    sendEvent(
      EventCategories.INQUIRY_BIDDING,
      'Add offline bid',
      'Shipper Bid List View',
    );
    history.push(getAddOfflineBidRoute(inquiryData.id), 'shipperBids');
  }

  toggleEditRRModal = (openState) => {
    this.setState({
      isEditRRModalActive: openState,
    });
  }

  renderModal = () => {
    const { inquiryData: data } = this.props;
    const { newDeadline, extendDeadlineModalVisible } = this.state;
    if (extendDeadlineModalVisible) {
      return (
        <ExtendDeadlineModal
          sailingDate={data.preferredSailingDate}
          deadline={newDeadline}
          inquiryId={data.id}
          shipperId={data.shipperId}
          visible={extendDeadlineModalVisible}
          handleOk={this.extendDeadlineModalHandleOk}
          handleCancel={this.extendDeadlineModalHandleCancel} />
      )
    }
    if (!this.state.inquiryData) return '';

    return <SendRFQ
    referenceNumber={data.referenceNumber}
    deadline={data.deadline}
    sentFfIds={this.state.inquiryData.sentFfIds}
    inquiryId={data.id}
    inquiryMode={data.mode}
    visible={this.state.sendRFQConfirmationVisible}
    handleOk={this.sendRFQConfirmationHandleOk}
    handleCancel={this.sendRFQConfirmationHandleCancel} />;
  }

  renderNoData = () => {
    const { classes, theme, permissions: {INQUIRY_VIEW_BIDS_ACTIONS} } = this.props;
    return (<div className={classes.notFound}>
      <div style={{ display: 'flex', alignItems: 'center',
        flexDirection: 'column', marginTop: '12%' }}>
      <div className={classes.notFoundItems}>
        <LightHouseIcon className={classes.blackIcon}
        width="184" height="184"></LightHouseIcon></div>
      <div className={classes.notFoundItems}
        style={{ fontWeight: tokens.fontWeight.semibold, fontSize: 16 }}>
        {!INQUIRY_VIEW_BIDS_ACTIONS ? 'Permission Required' : 'No bids received.'}</div>
      <div className={classes.notFoundItems}
        style={{ paddingTop: 10, fontSize: 14 }}>
        To get results, {INQUIRY_VIEW_BIDS_ACTIONS && <span
          onClick={this.state.inquiryData?.status === 'OPEN' ?
            this.showSendRfqModal
            :
            (this.state.inquiryData?.status === 'CLOSED' ?
            () => this.setState({ extendDeadlineModalVisible: true })
            :
            () => message.info(
              'Cannot perform the operation. Inquiry is either Closed or Confirmed.'))
          }
          style={{
            color : theme.primaryColor,
            cursor: 'pointer',
          }}>
            {this.state.inquiryData?.status === 'OPEN' ? 'send this inquiry' : 'extend inquiry timeline'}
          </span>} {INQUIRY_VIEW_BIDS_ACTIONS ? 'or try adjusting your filters.' : 'access to View Inquiries and Bids is required.'}</div>
        </div>
        {this.renderModal()}
      </div>);
  }

  extendDeadlineModalHandleOk = async (newDeadline) => {
    this.setState({ extendDeadlineModalVisible: false });
    this.setState({ newDeadline });
    this.setState({ isInquiryDataLoading: true });
    await this.loadInquiryData();
    this.setState({ isInquiryDataLoading: false });
    sendEvent(
      EventCategories.INQUIRY_SEND,
      'Edit Inquiry - Deadline Extended',
      'Inquiry Details Page'
    );
  }

  extendDeadlineModalHandleCancel = () => {
    this.setState({ extendDeadlineModalVisible: false });
  }

  renderFilters = () => {
    const { appliedFilters, classes, pagination, inquiryData } = this.props;
    const { clearVisible } = this.state;
    const showBidSidePanel = appliedFilters.bidIdList &&
                              appliedFilters.bidIdList.length ? 1 : 0;
    const shippingApplied = appliedFilters.shippingLineList &&
    appliedFilters.shippingLineList.length > 0 ? 1 : 0;
    const bidsTypeListApplied = appliedFilters.bidsTypeList?.length > 0 ? 1 : 0;
    const showPreSelectedBidsApplied = appliedFilters.showPreSelectedBids ? 1 : 0;

    const bidStatus = appliedFilters.bidStatusList &&
    appliedFilters.bidStatusList.length > 0 ? 1 : 0;
    const ffApplied = appliedFilters.ffIdList &&
    appliedFilters.ffIdList.length > 0 ? 1 : 0;
    const totalCnt = shippingApplied + ffApplied + showBidSidePanel + bidStatus + bidsTypeListApplied +
      showPreSelectedBidsApplied;
    const isFilterApplied = isValidArray(appliedFilters.shippingLineList) ||
      isValidArray(appliedFilters.ffIdList) ||
      isValidArray(appliedFilters.bidsTypeList) ||
      appliedFilters.showPreSelectedBids;
    return <>
      <span style={{
        marginLeft: '15px',
        height: '24px',
        cursor: 'pointer',
      }} onClick={() =>
        this.setState({
          ShipperBidsFilterModalVisible:
            !this.state.ShipperBidsFilterModalVisible,
        })}
        data-testid={'view-filters'}>
        <Tooltip title="Filters">
          <Icon type="filter"
            style={{ color: (isFilterApplied ? tokens.colors.primary : '#424242'), fontSize: `${tokens.fontSize.h3}px` }}
            theme={isFilterApplied ? 'filled' : 'outlined'}
          />
        </Tooltip>
        {totalCnt > 0 ?
        <span style={{ marginLeft: '8px', fontWeight: 600 }}>
        ({totalCnt})</span> : <span></span>}
      </span>
      <ShipperBidsFilterModal
        isCompareBids={this.state.compareBidsModalVisible}
        visible={this.state.ShipperBidsFilterModalVisible}
        handleOk={this.handleOkShipper}
        handleCancel={this.handleCancelShipper}
        id={this.props.inquiryData.id}
        inquiryMode={this.props.inquiryData.mode}
      />
      <span style={{
        height: '24px',
        marginLeft: '26px',
        cursor: 'pointer',
      }} onClick={() =>
        this.setState({
          ShipperBidsSortByModalVisible:
            !this.state.ShipperBidsSortByModalVisible,
        })}>
        <Tooltip title="Sort By">
          <SortIcon style={{
            height: '14px', width: '16px',
          }} />
        </Tooltip>
      </span>
      {clearVisible ? <div style={{
        marginLeft: '20px', cursor: 'pointer',
      }} onClick={this.clearFilters}>
      <span style={{ color:tokens.colors.primary, cursor:'pointer', fontWeight: 600 }}>Clear Filters</span>
        </div> : <div />}
      <ShipperBidsSortByModal visible={this.state.ShipperBidsSortByModalVisible}
        handleCancel={() => this.setState({ ShipperBidsSortByModalVisible: false })}
        id={this.props.inquiryData.id} compareBidModal={this.state.compareBidsModalVisible}
        mode={this.props.inquiryData.mode}
      />
    </>;
  }

  renderDownload = (downloadRequest) => {
    const { permissions: {INQUIRY_VIEW_BIDS_ACTIONS} } = this.props;
    const disabled = this.state.isDownloadLoading || !INQUIRY_VIEW_BIDS_ACTIONS;
    const menu = (
      <Menu onClick={({ key }) => {
        if (disabled) return;
        const payload = {
          ...downloadRequest,
          documentType: key,
        };
        this.handleDownload(payload);
      }}>
        <Menu.Item key="EXCEL">Excel <Icon type="download" /></Menu.Item>
        <Menu.Item key="PDF">PDF <Icon type="download" /></Menu.Item>
      </Menu>
    );

    const downloadIcon = (
      <Icon style={{
        color: disabled ? COLORS.LIGHTGREY : undefined,
        cursor: disabled ? 'default' : 'pointer',
      }} type="download" />
    );

    return <>
      {disabled ? downloadIcon :
        <Dropdown overlay={menu} trigger={['click']}>
          <span>{downloadIcon}</span>
        </Dropdown>}
      <span>{this.state.fileLink}</span>
    </>;
  }

  renderRateValue = () => {
    const { inquiryData, currencies, referenceRateBasis } = this.props;
    const { mode, referenceRate } = inquiryData;
    if (!referenceRate || !mode || !referenceRate.amount) return '-';
    return <div style={{ fontWeight: 'bold' }}>
      {mode !== InquiryModes.TRAILER && <span>
        {referenceRateBasis[referenceRate.basis]}
      </span>}
      <span style={{ fontSize: tokens.fontSize.caption, verticalAlign: 'top', marginLeft: '2%' }}>{
        currencies[referenceRate.currency]}
      </span>
      <span>
        {Number(referenceRate.amount).toFixed(2)}
      </span>
      <span style={{ fontSize: 8 }}>
        {getRefRateUnit(mode)}
      </span>
    </div>;
  }

  renderReferenceRate = () => {
    const { classes, permissions } = this.props;
    const { INQUIRY_CREATE_UPDATE_ACTIONS } = permissions;
    return <div className={classes.flexRow} style={{ width: '20%', padding: '10px 0px' }}>
      <div className={classes.verticalLine} style={{ marginRight: 20 }}></div>
      <div className={classes.flexColumn} style={{ width: '98%', fontSize: `${tokens.fontSize.small}px` }}>
        <div className={classes.flexRow} style={{ width: '98%', justifyContent: 'space-between' }}>
          <span>Reference Rate</span>
          {INQUIRY_CREATE_UPDATE_ACTIONS && (<a onClick={ () => this.toggleEditRRModal(true) }>
            <Icon type="edit"></Icon>
            Edit
          </a>)}
        </div>
        {this.renderRateValue()}
      </div>
    </div>;
  }

  renderFiltersForShipper = () => {
    const defaultSortBy = {
      sortBy: 'total_charge',
      descendingOrder: false,
    };
    const { appliedFilters, classes, pagination, inquiryData, allBidsForInquiry,
      allowSelfRaisedInquiryBid, loadInquiryData, isLoading, permissions } = this.props;
    const { INQUIRY_ALL_ACTIONS, INQUIRY_VIEW_BIDS_ACTIONS } = permissions;
    const { isInquiryDataLoading } = this.state;
    if (!inquiryData) return ;
    const {
      bidIdList,
      shippingLineList,
      bidStatusList,
      ffIdLis,
      bidsTypeList,
      showPreSelectedBids,
      sortBy,
      ffIdList,
    } = appliedFilters;
    const showBidSidePanel = bidIdList?.length ? 1 : 0;
    const shippingApplied = shippingLineList?.length > 0 ? 1 : 0;

    const bidStatus = bidStatusList?.length > 0 ? 1 : 0;
    const ffApplied = ffIdList?.length > 0 ? 1 : 0;
    const bidsTypeListApplied = bidsTypeList?.length > 0 ? 1 : 0;
    const showPreSelectedBidsApplied = showPreSelectedBids ? 1 : 0;
    const totalCnt = shippingApplied + ffApplied + showBidSidePanel + bidStatus + bidsTypeListApplied +
      showPreSelectedBidsApplied;

    const sortByOrderChanged = !(defaultSortBy.sortBy === appliedFilters.sortBy &&
      defaultSortBy.descendingOrder === appliedFilters.descendingOrder);
    totalCnt > 0 || sortByOrderChanged ?
    this.setState({ clearVisible : true }) : this.setState({ clearVisible : false });
    const downloadRequest = {
      shippingLineList: shippingLineList || [],
      bidStatusList: bidStatusList || false,
      sortBy: sortBy || 'total_charge',
      ffIdList: ffIdList || [],
      inquiryId: inquiryData.id,
      currentPageNumber: pagination.currentPageNumber ? pagination.currentPageNumber : 1,
      bidsTypeList: isValidArray(bidsTypeList) ? bidsTypeList : [],
      showPreSelectedBids: showPreSelectedBids,
    };
    const disabled = allBidsForInquiry && allBidsForInquiry instanceof Array
      && allBidsForInquiry.length === 0 ? true : false;
    const bidDeleted = appliedFilters.bidStatusList &&
    appliedFilters.bidStatusList[0] === 'DELETED' ? true : false;
    const isNonPreselectedBidPresent = allBidsForInquiry?.some(item => !item.isConfirmationRequiredForNegotiatedBid);
    const isInquiryOpen = moment(inquiryData.deadline) >= moment();
    
    return <Row style={{ width: '66%' }} className={classes.row2}>
      <Col span={1}>
        <div className={classes.verticalLine} style={{
          marginLeft: '15px',
          marginTop: '12px',
        }}></div>
      </Col>
      <Col span={12} className={classes.flexRow} style={{ marginTop: '18px' }}>
        {!INQUIRY_VIEW_BIDS_ACTIONS ? <div></div>: this.renderFilters()}
      </Col>
      <Col span={11} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Row className={classes.rightHeader} style={{ marginRight: '12px' }}>
          <Tooltip title={!INQUIRY_VIEW_BIDS_ACTIONS ? 'Permission Required' : "Reload"}>
              <Button
                icon="reload"
                onClick={!INQUIRY_VIEW_BIDS_ACTIONS ? undefined : this.loadBidData}
                disabled={!INQUIRY_VIEW_BIDS_ACTIONS}
              ></Button>
          </Tooltip>
        </Row>
        <Row className={classes.rightHeader} style={{ marginRight: '12px' }}>
          <div style={{ fontSize: '24px' }}>
            {this.renderDownload(downloadRequest)}
          </div>
        </Row>
        {inquiryData && inquiryData.ffsSentCount !== 0 && allowSelfRaisedInquiryBid && INQUIRY_ALL_ACTIONS && 
        ((inquiryData.mode === InquiryModes.DOMESTIC && disableAddOfflineBidForDomestic ) ? false : true) &&
          <Button size="large" className={classes.addBidsButton}
            disabled={!isInquiryOpen}
            onClick={() => isInquiryOpen ? this.handleAddOfflineBid() : undefined}
            style={
              isInquiryOpen 
              ? { backgroundColor: '#FCFCFC', border: '1px solid #0780FE', color: '#0780FE' }
              : undefined
            }>
            Add Offline Bid
        </Button>}
        <Tooltip placement="left" title={!INQUIRY_VIEW_BIDS_ACTIONS ? 'Permission Required' : disabled ? 'No bids to compare.' :
          bidDeleted || !isNonPreselectedBidPresent ?
          'Bid comparison is available for active bids only' :
          'Click to compare bids.'}>
          <Button disabled={disabled || bidDeleted || !isNonPreselectedBidPresent || !INQUIRY_VIEW_BIDS_ACTIONS}
            className={!(disabled || bidDeleted || !isNonPreselectedBidPresent) ?
              classes.compareBidsButton : classes.disabledButton}
            type="primary" size="large"
            onClick={() => !INQUIRY_VIEW_BIDS_ACTIONS ? null : this.handleCompareBids()}>
            Compare Bids
          </Button>
        </Tooltip>
        {this.state.compareBidsModalVisible && <CompareBidsModal 
          visible
          compareBidFilter={true}
          isLoading={isLoading || isInquiryDataLoading}
          cardData={this.state.inquiryData}
          captureReasonForNonL1Bid={this.props.captureReasonForNonL1Bid}
          handleCancel={this.handleCompareBidsCancel}
          renderFilters={this.renderFilters}
          downloadRequest={downloadRequest}
          renderDownload={this.renderDownload}
          renderNoData={this.renderNoData}
          allBidsForInquiry={this.props.allBidsForInquiry}
          refreshInquiryData={ async () => { await loadInquiryData(); }}
          exchangeRates={this.props.exchangeRates}
        />}
      </Col>
      <div style={{ float: 'right', margin: '8px 12px 8px 0px' }}>
        <TaxWarning unit={getUnitByMode(inquiryData.mode)}/>
      </div>
    </Row>;
  }

  header = () => {
    const { inquiryData, classes, timezone } = this.props;
   
    // Convert UTC deadline to shipper timezone for display
    const deadlineMoment = timezone && inquiryData.deadline
      ? momentTimezone(inquiryData.deadline).tz(timezone)
      : inquiryData.deadline ? moment(inquiryData.deadline) : null;
    
    const deadline = deadlineMoment 
      ? `${deadlineMoment.format('DD MMMM,YYYY | HH:mm')} Hrs` 
      : '-- : --';
    
    const { referenceNumber, otherDetails } = inquiryData;
    let deadlineString = deadline;
    let isDeadlineNear = false;
    let deadlineColor = '#424242';
    
    // For time comparisons, use UTC to ensure accuracy
    if (inquiryData.deadline && (moment(inquiryData.deadline) >= moment())) {
      if (moment(inquiryData.deadline) < moment().add(2, 'days')) {
        isDeadlineNear = true;
        const now = moment();
        const closingDate = moment(inquiryData.deadline);
        const difference = moment.duration(closingDate.diff(now));
        const hours = difference.asHours().toFixed(0);
        deadlineString = `${hours} hours left`;
        if (parseInt(hours, 10) <= 1) {
          const minutes = difference.asMinutes().toFixed(0);
          deadlineString = `${minutes} minutes left`;
        }
        deadlineColor = '#F5222D';
      }
    }
    return <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
      <div style={{ padding: '12px 16px 16px', width: '24%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{
            fontWeight: 'bold',
            fontSize: `${tokens.fontSize.h2}px`,
          }}> {referenceNumber}</div>
          {otherDetails?.isHighValueInsuranceRequired ? <div className={classes.highValue}>High Value Cargo</div> : null}
          </div>
        <div style={{ fontSize: `${tokens.fontSize.small}px`, color: `${deadlineColor}` }}>
          <Tooltip title={isDeadlineNear ? deadline : ''}>
            <Icon type="hourglass"
              style={{ marginRight: '8px', fontSize: `${tokens.fontSize.body}px`, color: `${deadlineColor}` }} />
            <span >{deadlineString}</span>
          </Tooltip>
        </div>
      </div>
      {this.renderReferenceRate()}
      {this.renderFiltersForShipper()}
    </div>;
  }

  render() {
    const {
      isLoading,
      allBidsForInquiry,
      appliedFilters,
      inquiryData,
      loadInquiryData,
      permissions: {INQUIRY_VIEW_BIDS_ACTIONS},
    } = this.props;
    const { isInquiryDataLoading } = this.state;
    const shippingApplied = appliedFilters.shippingLineList &&
    appliedFilters.shippingLineList.length > 0 ? 1 : 0;
    const ffApplied = appliedFilters.ffIdList &&
    appliedFilters.ffIdList.length > 0 ? 1 : 0;
    const bidStatus = appliedFilters.bidStatusList &&
    appliedFilters.bidStatusList.length > 0 ? 1 : 0;
    const bidsTypeList = appliedFilters.bidsTypeList?.length > 0 ? 1 : 0;
    const showPreSelectedBids = appliedFilters.showPreSelectedBids ? 1 : 0;
    const topBidData = allBidsForInquiry.find((bid) => bid.rank === '1');
    const totalCnt = shippingApplied + ffApplied + bidStatus + bidsTypeList + showPreSelectedBids;
    totalCnt > 0 ? this.setState({ clearVisible : true }) : this.setState({ clearVisible : false });

    return (<div style={{ backgroundColor : COLORS.GREY }}>
      {this.header()}
      { (isLoading || isInquiryDataLoading) &&
        <div style={{ height: '100%' }}>
          <Loader style={{position: 'fixed'}} zIndex={1} backgroundColor='rgb(255, 255, 255, 0.5)'/>
        </div> 
      }
      <div >
        <EditReferenceRateModal
          isModalActive={ this.state.isEditRRModalActive }
          onModalClose = { () => this.toggleEditRRModal(false) }
          inquiryId = { inquiryData.id }
          referenceRateData={ inquiryData.referenceRate }
          refreshInquiryData={ async () => { await loadInquiryData(); }}
          mode={inquiryData.mode}
        >
        </EditReferenceRateModal>
        <div>
          <Col style={{ backgroundColor: COLORS.GREY }}>
            <div style={{ paddingBottom: '7%' }}>
              {
                allBidsForInquiry && allBidsForInquiry.length !== 0 && INQUIRY_VIEW_BIDS_ACTIONS ?
                allBidsForInquiry.map((item) => {
                  return <BidCardShipper 
                  key={item.id}
                  isLoading={isLoading || isInquiryDataLoading}
                  cardData={item}
                  isFirstConfirmed={allBidsForInquiry[0].isConfirmed}
                  topBidData={topBidData}
                  captureReasonForNonL1Bid={this.props.captureReasonForNonL1Bid}
                  refreshInquiryData={ async () => { await loadInquiryData(); }}
                  inquiryData={this.props.inquiryData}
                  inquiryBookingStats={this.props.inquiryBookingStats}
                   />
                })
                : this.renderNoData()
              }
            </div>
          </Col>
        </div>
      </div>
    </div>);
  }
}

const mapStateToProps = ({ inquiryShipperBidsReducer, masterData, inquiryReducer }, ownProps) => ({
  isLoading: inquiryShipperBidsReducer.isLoading,
  allBidsForInquiry: inquiryShipperBidsReducer.allBidsForInquiry,
  appliedFilters: inquiryShipperBidsReducer.appliedFilters,
  inquiryBookingStats: inquiryShipperBidsReducer.inquiryBookingStats,
  pagination: inquiryShipperBidsReducer.pagination,
  allowSelfRaisedInquiryBid: masterData.modules.allow_self_raised_inquiry_bid,
  currencies: masterData.currencySymbols,
  referenceRateBasis: inquiryReducer.masterData.referenceRateBasis,
  captureReasonForNonL1Bid: masterData.modules.capture_reason_for_non_l1_bid,//Disabled from backend https://github.com/shipsy/jsw-analytics-api-server/commit/1eb2d1fa115706a3918e69818a1a917f816993d0,
  userCurrency: masterData?.userData?.user_metadata?.user_currency,
  permissions: masterData.permissions,
  timezone: masterData.timezone,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilter,
  applyFilter,
  resetFilters,
  getBidsEnquiry,
  enableBidLoading,
  disableBidLoading
}, dispatch));

const ShippersEnquiryStyled = injectSheet(styles)(ShippersEnquiry);
export default withInquiryMasterData(withRouter(connect(mapStateToProps,
  mapDispatchToProps)(withAuthAccessExim([INQUIRY_SHIPPER])(ShippersEnquiryStyled))));
